(function () {
    'use strict';

    angular
        .module('PWAPoCApp')
        .directive('debugPanel', debugPanel);

    debugPanel.$inject = ['consoleCapture', '$rootScope', 'translateService', 'cacheService'];

    function debugPanel(consoleCapture, $rootScope, translateService, cacheService) {

        var directive = {
            restrict: 'E',
            scope: false, 
            templateUrl: 'app/shared/directives/debugPanel/debug-panel.html',
            link: link
        };

        return directive;

        function link(scope, element, attrs) {

            scope.translate  = translateService.translate;

            scope.activeTab = 'console';

            scope.consoleLogs = consoleCapture.logs;
            scope.networkLogs = $rootScope.debugNetwork || [];

            scope.networkFilterText = '';
            scope.networkFilterMode = 'include';

            let cacheItems;
            scope.indexedDbLogs = []; 

            function getIndexedDbLogs() {
                scope.indexedDbLogs = [];
                cacheService.getAllKeysWithoutUserPrefix().then(function (items) {
                    cacheItems = items;
                    cacheItems.forEach(item => {
                        if (item.key.includes('_log')) {
                            const indexedDbLog = {
                                key: item.key,
                                value: item.value
                            }
                            scope.indexedDbLogs.push(indexedDbLog);
                        }
                    })
                });
            }

            scope.closePanel = function () {
                $rootScope.debugPanelVisible = false;
            };

            scope.setTab = function (tab) {
                scope.activeTab = tab;
                if (tab === 'logs') {
                    getIndexedDbLogs()
                }
            };

            scope.clearList = function(tab) {
                if (tab === 'console') {
                    consoleCapture.clear();
                } else if (tab === 'network') {
                    $rootScope.debugNetwork.length = 0;
                    $rootScope.$applyAsync();
                }
            }

            scope.filteredNetworkLogs = function () {
                const text = (scope.networkFilterText || '').toLowerCase();

                return scope.debugNetwork.filter(log => {
                    const url = (log.url || '').toLowerCase();

                    if (!text) return true;

                    const contains = url.includes(text);

                    if (scope.networkFilterMode === 'include') {
                        return contains;
                    } else {
                        return !contains;
                    }
                });
            };

            scope.refreshLogs = function () {
                getIndexedDbLogs();
            }
        }
    }

})();
